import React, { useState } from "react";
import { SUBSCRIBERS_BASE_URL } from "../services/SubscribersService";
import Swal from "sweetalert2";
import { useLogin } from "../hooks/useLogin";
import axios from "axios";

const Subscribe = () => {
  const [loading, setLoading] = useState(false);
  const { isLoading } = useLogin();
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({ email: "" });
  const [success, setSuccess] = useState(false);

  const { email } = formData;

  const handleInputChange = (e) => {
    setError(null);
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const createNewSubscriber = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${SUBSCRIBERS_BASE_URL}/api/subscribers/register-subscriber`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      setError(null);
      setSuccess(true);
      setFormData({ email: "" });

      Swal.fire({
        position: "center",
        icon: "success",
        title: "You're subscribed!",
        text: "Thank you for joining our community",
        showConfirmButton: false,
        timer: 2500,
        background: "#343a40",
        color: "#fff",
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Unable to subscribe. Please try again later.";
      setError(errorMessage);

      Swal.fire({
        icon: "error",
        title: "Subscription Failed",
        text: errorMessage,
        confirmButtonColor: "#ffc107",
        background: "#343a40",
        color: "#fff",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="subscribe-section bg-dark text-white py-5"
      id="subscribe"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
            {/* Decorative elements */}
            <div className="position-relative mb-5">
              <div className="position-absolute top-50 start-0 w-100 h-1 bg-gradient-primary opacity-25"></div>
              <i className="fa fa-envelope-open-o fa-3x text-warning position-relative px-4"></i>
              <div className="position-absolute top-50 end-0 w-100 h-1 bg-gradient-primary opacity-25"></div>
            </div>

            <h2 className="display-5 fw-bold mb-3 text-uppercase">
              Stay Updated
            </h2>
            <p className="lead mb-4 opacity-75 text-white">
              Join our newsletter to receive the latest updates, exclusive
              content, and special offers.
            </p>

            {success && (
              <div className="alert alert-success alert-dismissible fade show mb-4">
                <i className="fa fa-check-circle me-2"></i>
                Thank you for subscribing! Please check your email.
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSuccess(false)}
                ></button>
              </div>
            )}

            {error && (
              <div className="alert alert-danger alert-dismissible fade show mb-4">
                <i className="fa fa-exclamation-circle me-2"></i>
                {error}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setError(null)}
                ></button>
              </div>
            )}

            <form
              onSubmit={createNewSubscriber}
              className="needs-validation"
              noValidate
            >
              {/* Mobile layout (stacked) */}
              <div className="d-md-none mb-3">
                <input
                  type="email"
                  className={`form-control form-control-lg mb-2 ${
                    error ? "is-invalid" : ""
                  }`}
                  placeholder="Your email address"
                  aria-label="Email"
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  required
                />
                <button
                  className="btn btn-warning btn-lg w-100"
                  type="submit"
                  disabled={isLoading || !email || loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-paper-plane me-2"></i> Subscribe
                    </>
                  )}
                </button>
              </div>

              {/* Desktop layout (inline) */}
              <div className="d-none d-md-block">
                <div className="input-group input-group-lg mb-3">
                  <input
                    type="email"
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    placeholder="Your email address"
                    aria-label="Email"
                    name="email"
                    value={email}
                    onChange={handleInputChange}
                    required
                  />
                  <button
                    className="btn btn-warning"
                    type="submit"
                    disabled={isLoading || !email || loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Processing...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-paper-plane me-2"></i> Subscribe
                      </>
                    )}
                  </button>
                </div>
              </div>

              <div className="mt-2">
                <small className="text-white-50">
                  We respect your privacy. Unsubscribe at any time.
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscribe;
